<template>
  <div class="main-products-section">
    <!-- 顶部标题栏 -->
    <div class="section-header">
      <div class="title-group">
        <p class="sub-title">Main Products</p>
        <h2 class="main-title">What We Do</h2>
      </div>
      <el-button class="all-products-btn" @click="goAllProducts">
        All Products
      </el-button>
    </div>

    <!-- 产品展示区域 -->
    <div class="product-grid">
      <div
          class="product-card"
          v-for="item in prodList"
          :key="item.productNo"
          @click="goDetail(item.productNo)"
      >
        <div class="card-img">
          <img :src="item.mainImage" alt="" />
        </div>
        <div class="card-name">{{ item.productName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMainProducts } from '../../api/system'
import ScrollReveal from 'scrollreveal'

export default {
  data() {
    return {
      prodList: []
    }
  },
  methods: {
    async getMainProductList() {
      try {
        const res = await getMainProducts();
        if (res.data.code === 200) {
          this.prodList = res.data.data || [];

          this.$nextTick(() => {
            this.initScrollAnimation()
          })
        }
      } catch (err) {
        console.error('获取主要产品失败', err);
      }
    },

    goDetail(productNo) {
      this.$router.push('/production/detail?productNo=' + productNo);
    },

    goAllProducts() {
      this.$router.push('/production/1').catch(() => {});
    },

    // 优化动画配置：延迟触发、加大入场距离、放慢节奏
    initScrollAnimation() {
      const config = {
        distance: '40px',    // 入场偏移距离加大，动画更明显
        duration: 1000,      // 动画时长拉长
        interval: 150,       // 卡片逐个出现间隔加大
        origin: 'bottom',
        reset: false,
        viewFactor: 0.5,     // 元素50%进入视口才触发（核心：不会提前加载）
        delay: 100           // 整体延迟启动
      }
      ScrollReveal().reveal('.section-header', config)
      ScrollReveal().reveal('.product-card', config)
    }
  },
  mounted() {
    this.getMainProductList();
  }
}
</script>

<style lang="scss" scoped>
.main-products-section {
  width: 100%;
  background-color: #e8eef2;
  padding: 60px 0;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    padding: 40px 15px;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 96%;
    margin: 0 auto 40px;
    padding: 0;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
      margin-bottom: 30px;
      width: 100%;
    }

    .title-group {
      .sub-title {
        color: #880f53;
        font-size: 20px;
        font-weight: bold;
        margin: 0 0 10px;
        font-family: 'Roboto_Bold', sans-serif;

        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      .main-title {
        color: #000;
        font-size: 48px;
        font-weight: bold;
        margin: 0;
        font-family: 'Roboto_Bold', sans-serif;

        @media (max-width: 768px) {
          font-size: 28px;
        }
      }
    }

    .all-products-btn {
      background-color: #880f53;
      color: #fff;
      border: none;
      padding: 20px 55px;
      font-size: 18px;
      font-weight: bold;
      font-family: 'Roboto_Bold', sans-serif;
      border-radius: 0;
      margin: 0;
      align-self: flex-end;

      &:hover {
        background-color: #6f063f;
      }

      @media (max-width: 768px) {
        padding: 14px 30px;
        font-size: 16px;
        align-self: flex-start;
      }
    }
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 36px;
    width: 96%;
    margin: 0 auto;

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      width: 100%;
    }
  }

  .product-card {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    width: 100%;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
    }

    .card-img {
      width: 100%;
      height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background-color: #fff;

      @media (max-width: 768px) {
        height: 220px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        transition: transform 0.3s ease;
      }
    }

    &:hover .card-img img {
      transform: scale(1.1);
    }

    .card-name {
      width: 100%;
      padding: 16px 0;
      background-color: transparent;
      color: #000;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      font-family: 'Roboto_Bold', sans-serif;

      @media (max-width: 768px) {
        font-size: 14px;
        padding: 10px 0;
      }
    }
  }

  .empty-tip {
    grid-column: 1 / -1;
    text-align: center;
    padding: 60px 0;
    font-size: 16px;
    color: #666;
  }
}
</style>